<template>
    <div class="gofixTextField" v-bind:class="{gofixTextFieldOneLine:oneline,gofixTextFieldValueSmall:valueSmall,gofixTextFieldInputStyle:inputStyle,}">
        <slot name="gofixTextField:before"></slot>
        <div :class="['inner', classInner]">
            <div class="label" v-bind:class="classLabel">
                <slot name="gofixTextField:before_label"></slot>
                {{label}}
                <slot name="gofixTextField:after_label"></slot>
            </div>
            <div class="value" :class="classValue">
                <slot name="gofixTextField:before_value"></slot>
                <slot>{{value}}</slot>
                <slot name="gofixTextField:after_value"></slot>
            </div>
        </div>
        <slot name="gofixTextField:after"></slot>
    </div>
</template>

<script>
    export default {
        name: "gofix-tab",
        props: {
            label: {
                type: String,
                required: false,
                default: () => null
            },
            value: {
                type: String,
                required: false,
                default: () => null
            },
            oneline: {
                type: Boolean,
                required: false,
                default: () => false
            },
            valueSmall: {
                type: Boolean,
                required: false,
                default: () => false
            },
            inputStyle: {
                type: Boolean,
                required: false,
                default: () => false
            },
            classLabel: {
                type: String,
                required: false,
                default: () => null
            },
            classValue: {
                type: String,
                required: false,
                default: () => null
            },
            classInner: {
                type: String,
                required: false,
                default: () => null
            },
        },
        data() {
            return {

            }
        },

        created(){

        },
        mounted () {

        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
